var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsultancyTraining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-2",
    d: "M87.38,419.89c90.43,46.48,237,46.48,327.45,0s90.43-121.83,0-168.3-237-46.47-327.45,0S-3,373.42,87.38,419.89Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-2",
    d: "M335.91,367.8l50.45-29.12a6.06,6.06,0,0,1,5-.23l51.45,29.7c1.41.65,1.47,1.81.12,2.59l-51.42,29.61a4.74,4.74,0,0,1-4.73-.24l-51-29.25A1.69,1.69,0,0,1,335.91,367.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 254.85,
    cy: 318.61,
    rx: 51.51,
    ry: 24.55,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.79,354.07c.09-4.71,3.66-14.41,8.66-20.44s12.76-10.37,18.18-8.41c5.06,1.83,4.39,8.49-1.86,12.8s-15.61,9.71-18.46,17.3l-5.85,9.28Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.79,354.07c.09-4.71,3.66-14.41,8.66-20.44s12.76-10.37,18.18-8.41c5.06,1.83,4.39,8.49-1.86,12.8s-15.61,9.71-18.46,17.3l-5.85,9.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.33,360.51a.34.34,0,0,0,.32-.27c3.43-16,16.67-28.87,24.5-31.62a.36.36,0,0,0,.22-.44.34.34,0,0,0-.44-.21c-8,2.8-21.47,15.85-24.95,32.12a.35.35,0,0,0,.26.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.55,370.84c.81-2.63,4.12-6.95,9.41-10.46,5.86-3.9,13.21-5.6,15-8.68,2.1-3.7-1-7.28-7-6.65s-16.54,8.56-18.43,20.74Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.45,368a.35.35,0,0,0,.3-.22c5.17-13.69,15.77-18.34,20.65-18.89a.35.35,0,0,0,.3-.38.33.33,0,0,0-.38-.3c-5.4.6-15.93,5.35-21.21,19.33a.34.34,0,0,0,.34.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.32,339l5.92-3.38s2.84-15.64.72-29.08c-3-18.9-15.86-25.42-20.53-23.54s-5.77,7.48,2.67,18.4C97.08,307.85,103.48,321.47,103.32,339Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.32,339l5.92-3.38s2.84-15.64.72-29.08c-3-18.9-15.86-25.42-20.53-23.54s-5.77,7.48,2.67,18.4C97.08,307.85,103.48,321.47,103.32,339Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.47,331.51h-.06a.42.42,0,0,1-.36-.47c2.45-17.7-4.67-37.08-12.66-44.89a.42.42,0,0,1,.59-.61c8.14,8,15.39,27.66,12.91,45.61A.43.43,0,0,1,105.47,331.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.91,348.5c-.94.53-2.86-.64-3.6-1.14a8.87,8.87,0,0,1-3-3.4,8.35,8.35,0,0,1-.74-5,18.86,18.86,0,0,1,.64-2.67c.24-.87.49-1.73.74-2.6a6.5,6.5,0,0,0,.38-2.61c-.23-1.77-1.8-3-3.23-4.08s-3.23-2.75-3.22-4.89a7.52,7.52,0,0,1,1.88-4.46c1-1.3,2.23-2.44,3.15-3.8A5.26,5.26,0,0,0,81,310.51a5.41,5.41,0,0,0-.73-2.07A29.84,29.84,0,0,1,78,304.29a4.17,4.17,0,0,1,.72-4.42,4.84,4.84,0,0,1,3.67-.91,8.11,8.11,0,0,1,3.41,1.2c3.39,1.88,5.32,5.89,8.92,7.34a37.82,37.82,0,0,0,4.35,1.07,5.37,5.37,0,0,1,3.59,2.45c1.32,2.64-1.13,5.89-.2,8.69.82,2.47,3.22,3.42,4.58,5.65a5.33,5.33,0,0,1,.63,3.24,15.58,15.58,0,0,1-1.37,5.48,38.2,38.2,0,0,1-3,4.93C103.27,339.07,87.05,348.41,86.91,348.5Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.51,343.38h0a.42.42,0,0,1-.41-.44c.7-16.75-7.19-35.24-12.93-40.61a.41.41,0,0,1,0-.59.43.43,0,0,1,.6,0c5.85,5.47,13.9,24.27,13.2,41.25A.43.43,0,0,1,96.51,343.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,323.59a.25.25,0,0,1-.12,0,57.48,57.48,0,0,0-12.15-2,.42.42,0,1,1,0-.84,57.27,57.27,0,0,1,12.37,2,.42.42,0,0,1,.28.53A.43.43,0,0,1,94,323.59Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "157.13 279.79 157.13 277.39 114.48 302.06 116.51 303.26 157.13 279.79",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,117.37a.59.59,0,0,1,.27.62L68.88,274.87l-1,4.45a2.71,2.71,0,0,1-1.41-.28l0,0-2.37-1.37a.58.58,0,0,1-.27-.62l36.28-161a.57.57,0,0,1,.84-.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,115.23,71.92,277a1,1,0,0,1-.45.61L69.1,279a2.46,2.46,0,0,1-1.23.3l1-4.45,35.43-157.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.45,333.29V338a2.75,2.75,0,0,1-1.31-.3l0,0-2.2-1.27a.92.92,0,0,1-.53-.76V195.12l4.07,2.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.52,195.13V335.67a.93.93,0,0,1-.54.71l-2.19,1.27a2.62,2.62,0,0,1-1.33.32V197.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18,307.53a2.75,2.75,0,0,1-1.27-.37l-2.26-1.31a1.16,1.16,0,0,1-.56-.78l-24.23-126.4,4.07,2.35,23.38,122Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,305.16v0a1,1,0,0,1-.56.77l-2.07,1.2-.1.06a2.75,2.75,0,0,1-1.33.32l-.87-4.55L140.93,181l4.08-2.34L169.2,305v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.11 308.74 161.19 282.14 161.19 277.45 115.11 304.05 115.11 308.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.52,239.08v1.69a2.87,2.87,0,0,0,1.3,2.25l13.65,7.88a2.88,2.88,0,0,0,2.59,0l115.21-66.51a2.89,2.89,0,0,0,1.29-2.25v-1.69a2.87,2.87,0,0,0-1.29-2.25l-13.65-7.88a2.84,2.84,0,0,0-2.6,0L52.82,236.83A2.86,2.86,0,0,0,51.52,239.08Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.82,238.33l13.65,7.88a2.88,2.88,0,0,0,2.59,0L184.27,179.7a.79.79,0,0,0,0-1.5l-13.65-7.88a2.84,2.84,0,0,0-2.6,0L52.82,236.83C52.1,237.24,52.1,237.91,52.82,238.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,246.52v4.69a2.67,2.67,0,0,1-1.29-.31L52.82,243a2.89,2.89,0,0,1-1.3-2.25v-1.69a2.88,2.88,0,0,1,1-2.07c-.45.41-.36,1,.26,1.32l13.65,7.88A2.7,2.7,0,0,0,67.76,246.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.54,243.36l-3.8-2.19a5.19,5.19,0,0,1-2.31-3.74L47.6,101.7a4.43,4.43,0,0,1,2-3.74L163.09,32.45a4.79,4.79,0,0,1,4.33,0l3.8,2.19a5.15,5.15,0,0,1,2.3,3.74l7.84,135.73a4.45,4.45,0,0,1-2,3.74L65.87,243.36A4.79,4.79,0,0,1,61.54,243.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.47,38c-.23-1.1-1.17-1.49-2.26-.87L57.74,102.65a4.14,4.14,0,0,0-1.49,1.63l-8.13-4.69A4.24,4.24,0,0,1,49.62,98L163.09,32.45a4.8,4.8,0,0,1,4.32,0l3.82,2.2A5.2,5.2,0,0,1,173.47,38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.72,106.4l7.84,135.72a1.41,1.41,0,0,0,2.31,1.24l113.47-65.51a4.45,4.45,0,0,0,2-3.74L173.52,38.38a1.41,1.41,0,0,0-2.3-1.24L57.74,102.65A4.46,4.46,0,0,0,55.72,106.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88,55.7V63a2,2,0,0,1-.91,1.58L93.05,91.65a2,2,0,0,1-1.82,0L89,90.35a2,2,0,0,1-.9-1.57V85.14L80,80.45l-4,2.34V74.46a2,2,0,0,1,.91-1.57l46.92-27.1a2,2,0,0,1,1.82,0L140,54.12A2,2,0,0,1,140.88,55.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88,55.7V63a2,2,0,0,1-.91,1.57L93.05,91.65a1.94,1.94,0,0,1-.91.21V82.49a1.91,1.91,0,0,0,.91-.22L140,55.17c.44-.25.49-.65.16-.93A2,2,0,0,1,140.88,55.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8,73.94l14.43,8.33a2,2,0,0,0,1.82,0L140,55.17a.56.56,0,0,0,0-1.05l-14.43-8.33a2,2,0,0,0-1.82,0L76.8,72.89A.55.55,0,0,0,76.8,73.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.55,132.71c.56,9.68,7.94,13.53,16.49,8.6s15-16.78,14.46-26.47S92.56,101.31,84,106.25,69,123,69.55,132.71Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,104.92,85,123.78l-1-17.53C88.15,103.87,92,103.53,95,104.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.11,126.93,85,123.78,95,104.92c3.15,1.47,5.27,4.92,5.56,9.93A27.34,27.34,0,0,1,98.11,126.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.21,103.21l.09,1.54a.85.85,0,0,0,1.38.75L162.2,75.19a2.68,2.68,0,0,0,1.21-2.25l-.08-1.54a.85.85,0,0,0-1.39-.75L109.43,101A2.68,2.68,0,0,0,108.21,103.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37,112l.15,2.54a1.79,1.79,0,0,1-.81,1.5L109.88,117a.56.56,0,0,1-.92-.5l-.14-2.54a1.79,1.79,0,0,1,.81-1.5l1.82-1A.56.56,0,0,1,112.37,112Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.83,86.48,118,112.33a.85.85,0,0,1-1.38-.75l-.08-1.54a2.67,2.67,0,0,1,1.21-2.25l44.79-25.85a.85.85,0,0,1,1.38.75l.09,1.55A2.64,2.64,0,0,1,162.83,86.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.88,123.34l.14,2.54a1.79,1.79,0,0,1-.81,1.5l-1.82,1.05a.56.56,0,0,1-.92-.5l-.14-2.54a1.79,1.79,0,0,1,.81-1.5l1.82-1A.56.56,0,0,1,112.88,123.34Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.88,123.34l.14,2.54a1.79,1.79,0,0,1-.81,1.5l-1.82,1.05a.56.56,0,0,1-.92-.5l-.14-2.54a1.79,1.79,0,0,1,.81-1.5l1.82-1A.56.56,0,0,1,112.88,123.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.34,97.87l-44.81,25.86a.85.85,0,0,1-1.38-.75l-.08-1.54a2.68,2.68,0,0,1,1.21-2.25l44.81-25.86a.85.85,0,0,1,1.38.75l.09,1.55A2.67,2.67,0,0,1,163.34,97.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.38,134.83l.15,2.53a1.79,1.79,0,0,1-.81,1.5l-1.84,1.06a.57.57,0,0,1-.92-.5l-.14-2.53a1.76,1.76,0,0,1,.81-1.5l1.83-1.06A.56.56,0,0,1,113.38,134.83Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.38,134.83l.15,2.53a1.79,1.79,0,0,1-.81,1.5l-1.84,1.06a.57.57,0,0,1-.92-.5l-.14-2.53a1.76,1.76,0,0,1,.81-1.5l1.83-1.06A.56.56,0,0,1,113.38,134.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.83,109.36,119,135.21a.85.85,0,0,1-1.38-.75l-.08-1.53a2.67,2.67,0,0,1,1.21-2.25l44.8-25.86a.85.85,0,0,1,1.38.75l.09,1.54A2.68,2.68,0,0,1,163.83,109.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.13,154.38l21.72-12.57a.85.85,0,0,1,1.39.75l.21,3.63a2.67,2.67,0,0,1-1.21,2.25L76.51,161a.85.85,0,0,1-1.39-.75l-.21-3.63A2.68,2.68,0,0,1,76.13,154.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6,183.77l31.92-18.43a.85.85,0,0,1,1.38.75l.09,1.54a2.64,2.64,0,0,1-1.21,2.25L71.86,188.31a.85.85,0,0,1-1.38-.75L70.39,186A2.64,2.64,0,0,1,71.6,183.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3,195.88l31.92-18.44a.84.84,0,0,1,1.38.74l.09,1.55a2.66,2.66,0,0,1-1.21,2.25L72.56,200.4a.85.85,0,0,1-1.38-.74l-.09-1.53A2.66,2.66,0,0,1,72.3,195.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,208l31.92-18.46a.85.85,0,0,1,1.38.75l.09,1.54a2.64,2.64,0,0,1-1.21,2.25L73.26,212.5a.85.85,0,0,1-1.38-.75l-.09-1.51A2.68,2.68,0,0,1,73,208Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.71,220.1l31.91-18.47a.85.85,0,0,1,1.39.74l.09,1.55a2.7,2.7,0,0,1-1.22,2.25L74,224.59a.85.85,0,0,1-1.39-.75l-.08-1.49A2.67,2.67,0,0,1,73.71,220.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.78,165.34l4.59-2.65a.85.85,0,0,1,1.38.75l1.42,24.16a2.66,2.66,0,0,1-1.21,2.25l-4.59,2.64a.85.85,0,0,1-1.39-.74l-1.41-24.16A2.66,2.66,0,0,1,115.78,165.34Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.63,197l4.59-2.65c.72-.41,1.33-.24,1.37.39a2.39,2.39,0,0,1-1.24,1.88l-4.59,2.65c-.71.42-1.33.25-1.36-.38A2.38,2.38,0,0,1,117.63,197Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.12,167.77l4.59-2.65a.85.85,0,0,1,1.39.75l.74,12.66a2.67,2.67,0,0,1-1.21,2.25L133,183.43a.85.85,0,0,1-1.39-.75L130.91,170A2.67,2.67,0,0,1,132.12,167.77Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.12,167.77l4.59-2.65a.85.85,0,0,1,1.39.75l.74,12.66a2.67,2.67,0,0,1-1.21,2.25L133,183.43a.85.85,0,0,1-1.39-.75L130.91,170A2.67,2.67,0,0,1,132.12,167.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,188l4.59-2.65c.72-.41,1.33-.24,1.36.39a2.37,2.37,0,0,1-1.23,1.88l-4.59,2.65c-.72.41-1.33.24-1.36-.39A2.37,2.37,0,0,1,133.3,188Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.78,140.27l4.59-2.65a.85.85,0,0,1,1.38.75l1.76,31.1a2.68,2.68,0,0,1-1.21,2.25l-4.59,2.65a.85.85,0,0,1-1.39-.75l-1.75-31.1A2.66,2.66,0,0,1,146.78,140.27Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.78,140.27l4.59-2.65a.85.85,0,0,1,1.38.75l1.76,31.1a2.68,2.68,0,0,1-1.21,2.25l-4.59,2.65a.85.85,0,0,1-1.39-.75l-1.75-31.1A2.66,2.66,0,0,1,146.78,140.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,178.91l4.59-2.65c.71-.42,1.33-.25,1.36.38a2.38,2.38,0,0,1-1.23,1.89l-4.59,2.65c-.72.41-1.33.24-1.37-.39A2.39,2.39,0,0,1,149,178.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.25,144.94l4.59-2.65a.85.85,0,0,1,1.38.75l1,17.37a2.65,2.65,0,0,1-1.22,2.24l-4.59,2.65a.85.85,0,0,1-1.38-.74l-1-17.37A2.68,2.68,0,0,1,163.25,144.94Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.25,144.94l4.59-2.65a.85.85,0,0,1,1.38.75l1,17.37a2.65,2.65,0,0,1-1.22,2.24l-4.59,2.65a.85.85,0,0,1-1.38-.74l-1-17.37A2.68,2.68,0,0,1,163.25,144.94Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.64,169.84l4.59-2.65c.71-.41,1.32-.24,1.36.39a2.39,2.39,0,0,1-1.23,1.88l-4.59,2.65c-.72.42-1.33.24-1.37-.38A2.42,2.42,0,0,1,164.64,169.84Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.07,190.29l7.8-4.59c.53,1.39,1,2.61,1.46,3.61s2.44,2.23,3.4,2.67c2.55,1.17,3.7,2.56,5.72,4.19,1.58,1.28,2.82,1.49,2.69,2a2.3,2.3,0,0,1-2.8,1.42,16.43,16.43,0,0,1-3.59-1.38,21.63,21.63,0,0,0,4.2,5.45c3.84,3.63,4.31,6.11-2.37,7-4.18.58-7.86-1.57-12.22-10.4A76.17,76.17,0,0,1,277.07,190.29Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.91,112.82a53.44,53.44,0,0,1-3.2,7.24c-1.27,2.17-.2,36.79.44,39.69S276.46,191,276.46,191a10.62,10.62,0,0,0,9.92-3.09L277,158.24,276.37,133S276.74,114.75,265.91,112.82Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.91,112.82a53.44,53.44,0,0,1-3.2,7.24c-1.27,2.17-.2,36.79.44,39.69S276.46,191,276.46,191a10.62,10.62,0,0,0,9.92-3.09L277,158.24,276.37,133S276.74,114.75,265.91,112.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.21,
    y: 296.54,
    width: 9.37,
    height: 16.04,
    transform: "translate(461.79 609.12) rotate(180)",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.52 300.44 273.88 300.76 274.35 283.79 264.52 283.47 264.52 300.44",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.53,182.07c0,9-.62,61-.62,61-.22,2.57-2.69,7.15-2.89,16.42-.28,13.44,1.79,45.11,1.79,45.11a12.32,12.32,0,0,0,10.43.21s7.36-44.8,9-58.1c1.46-11.62,6.52-42.62,6.52-42.62L259,243.31a53.47,53.47,0,0,0-1.16,14.88c.44,6.16,6.14,37,6.14,37a12.81,12.81,0,0,0,10.82.83s.56-48.4.66-54c.13-6.44-2.68-61.82-2.68-61.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.58,308v-1.33c.5,0,.81.48,1,1.69.14.86.27,1.51.55,2.65a32.1,32.1,0,0,0,1.64,4.79c1.32,3.27,2.43,4.48,5.47,8.3a35.44,35.44,0,0,1,2.91,3.35c.56,1,.76,3.81-.2,4.45-3.54,2.36-8.91,2.42-12.71,1.31a7.66,7.66,0,0,1-5.51-6.2c-.14-.86-.09-1.74-.19-2.61a12.36,12.36,0,0,0-2.35-5.44,16.31,16.31,0,0,1-1.79-3c-.79-1.93-.16-4.1.34-6,.44-1.66.91-3.48,1.47-3.33v1a7.43,7.43,0,0,0,4.69,1.58C232.27,309.27,235.59,309,235.58,308Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,297.87c.49,0,.89.7,2,1.86a20.49,20.49,0,0,0,5.51,4c3.51,1.75,10.33,4.45,13.41,5.84,1.93.87,1.84,3.2-.15,4.53s-6.81,2.28-12.58,1c-3.15-.71-7.25-3.62-9.84-3.46s-7.45.12-9.36-1.2-1.15-4.14-.61-6.56c.59-2.64,1.33-6.76,2.2-6.58v.91c1.13,1.71,6.94,2.4,9.42,1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.8,204.05a34.73,34.73,0,0,0,13-7.48s-2.52,4.71-10,9.1l3.62,34.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.77,113.45c-3.18.77-9.61,1.82-11.05,8.17-1.73,7.62-2.3,24.23-2.3,24.23l-.59,37c6.45,4.69,30.15,7.25,43.72-2.66,0,0-1.66-44.37-1.66-51.27s-3.84-15.21-14.43-15.82Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.31,112.33s4.76,3.78,6.05,9.37,1.5,68,1.5,68,6.62-1.22,9.72-3.66c0,0-.4-49.25-1-57.39-1-12.35-.85-15.91-16.23-17.21Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,111.42s8.83,5.43,8.92,27c.09,18.68.71,51.22.71,51.22s-14.61,2.15-23.87-3.38c0,0-1.1-45.31-.93-52.32.2-8,2.08-18.42,4.66-19.45A73.41,73.41,0,0,1,241,111.42Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.73,126.35c-4.14,7-13.1,21.2-13.1,21.2-.79-.62-19.63-12.42-23.88-17.69a30.62,30.62,0,0,0-3.2-5.65c-1.62-2.12-3.3-4.19-5-6.23a1.9,1.9,0,0,0-.44-.41c-.64-.38-1.49.18-1.7.89a3.72,3.72,0,0,0,.25,2.17c.3.92,1.24,2.2-.07,2.42a6.28,6.28,0,0,1-3.25-.73c-1.66-.72-3.3-1.51-4.9-2.36a7.38,7.38,0,0,0-3.28-1.17,4.2,4.2,0,0,0-3.82,2.9,6.27,6.27,0,0,0,.6,4.94,12.55,12.55,0,0,0,3.44,3.75c2.93,2.27,6.81,3.31,10.36,4.25a15.93,15.93,0,0,1,5,2.34c2.83,2,17.57,14.54,24.63,19.7,6.39,4.68,8.19,2.85,11.92-.93s17.79-21.55,17.79-21.55Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,113.57c-9.58,2.8-8.94,6.19-15.32,16.38s-10.65,14.8-10.65,14.8l-20.36-12.83a19.16,19.16,0,0,0-6.53,8.36s20.47,15.88,23.32,17.66c4.06,2.54,6.15,3.52,9.48.7S229.83,141,229.83,141C236,134.79,237.28,118.16,233.08,113.57Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,113.57c-9.58,2.8-8.94,6.19-15.32,16.38s-10.65,14.8-10.65,14.8l-20.36-12.83a19.16,19.16,0,0,0-6.53,8.36s20.47,15.88,23.32,17.66c4.06,2.54,6.15,3.52,9.48.7S229.83,141,229.83,141C236,134.79,237.28,118.16,233.08,113.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.99 123.23 244.03 128.24 242.01 133.93 247.32 147.55 240.92 133.93 243.16 128.56 239.99 123.23",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.5 121.62 267.63 126.8 271.13 131.35 266.26 146.69 270.03 131.52 266.8 127.26 268.5 121.62",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.93,
    cy: 82.66,
    r: 12.87,
    transform: "translate(17.39 207.3) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.68,91.82s2.08,9.8,2.92,11.41a4.42,4.42,0,0,0,2.56,2.07L242,98.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.29,77.78a4.8,4.8,0,0,0-4,1.4c-1.72,1.76-.76,7.25,1.38,12.64l3.92.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,92.27c-.79.47-1.91-1-2.88-2.06s-4.14-2.4-5.73.93,1.4,7.89,3.9,8.67c4.3,1.35,5-1.41,5-1.41l.31,16h0c3,3.81,9.67,8.3,13.26,7.66,2.88-.51,3.5-5.37.76-8.55v-4.72a27.31,27.31,0,0,0,5.8.3c3.16-.49,5.15-3,6.11-6.41,1.54-5.51,2.13-10,.82-20.77-1.43-11.86-15.23-12-22.68-7.3S241.78,92.27,241.78,92.27Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,93.6c-.39,0-1.9-2.5-2.88-3.39-1.36-1.24.39-12.43.39-12.43a5.44,5.44,0,0,1,.94-6c1.86-2,4.46-4.55,12.91-3.55,6,.71,12.57,2.59,17.87,0a9,9,0,0,1-3.14,9.57s-1.92,1.24-7,1.85-12.89-.12-14-.26c-1.46-.2-1.77,1.21-2.56,5.08C243.69,87.81,243.11,93.57,241.78,93.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3,78.65l-4.76-2.56a2.62,2.62,0,0,1,3.6-1.19A2.83,2.83,0,0,1,239.3,78.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.34,108.79s-7.07-1.42-9.54-2.74a8.17,8.17,0,0,1-3.41-3.37,11.08,11.08,0,0,0,1.94,4c1.8,2.31,11,4,11,4Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.64,90.5A1.42,1.42,0,1,1,253.22,89,1.44,1.44,0,0,1,254.64,90.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.14,85.16l-3,1.67a1.81,1.81,0,0,1,.7-2.41A1.7,1.7,0,0,1,253.14,85.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,100.28l3.23,1.22a1.71,1.71,0,0,1-2.2,1.07A1.81,1.81,0,0,1,255.7,100.28Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.26,86.34l-2.76-2.13a1.68,1.68,0,0,1,2.4-.37A1.83,1.83,0,0,1,267.26,86.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.41,90.1A1.42,1.42,0,1,1,265,88.63,1.44,1.44,0,0,1,266.41,90.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.2 88.76 259.66 97.27 264.11 95.76 259.2 88.76",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.74,121.08c-.87,2.06-2.47,2.9-5.38,3.23a10.74,10.74,0,0,1-8-2.8l3.61-3.59,4.58,3.45.39-3.85Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.74,121.08c-.87,2.06-2.47,2.9-5.38,3.23a10.74,10.74,0,0,1-8-2.8l3.61-3.59,4.58,3.45.39-3.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.46,120a9.6,9.6,0,0,1,.48,3.87,6.63,6.63,0,0,1-1.29,3.22,3.54,3.54,0,0,1-3.12.34,8.54,8.54,0,0,1-3-6.46l4,.45Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.65,127s4.7,26,4.89,28-2.7,9.54-4.49,9.6-5.31-6.67-5.37-8.57,1.85-28.73,1.85-28.73Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.53,127.38a3.14,3.14,0,0,0,3.12-.34l.07.41a3.58,3.58,0,0,1-3.24.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.52,121.37l-13.25-10.09-.06-3s-3.08,1.16-3.77,6.6a23.44,23.44,0,0,0,10.33,11l2.78-5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.34,109.66a6.62,6.62,0,0,1,4.27,2.63c1.32,2.18,1,10.54,1,10.54L258.46,120l-2.94,1.42c.28-2.79.83-7.86.83-7.86Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.39,345.66c.53.71.63,2.33,1.16,4.52s.72,3.89.36,5a8.34,8.34,0,0,1-5.6,4.38,11.06,11.06,0,0,1-7.83-1.69c-3.44-2.06-4.79-3.63-12.64-4.2a18.49,18.49,0,0,1-11-4.55c-3-2.69-2.3-7.46,2.94-7.43,6.29,0,15.11,1.14,23.64,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.81,335.79c.53.71.63,2.33,1.16,4.52s.72,3.89.36,5a8.34,8.34,0,0,1-5.6,4.38A11.06,11.06,0,0,1,356.9,348c-3.44-2.06-4.79-3.63-12.64-4.2a18.49,18.49,0,0,1-11-4.55c-3-2.69-2.3-7.46,2.94-7.43,6.29,0,15.11,1.14,23.64,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.83,329.18v7.7s-1.06,2.56-5.45,2.72a6.64,6.64,0,0,1-5.83-2.78v-7.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.12,278.8c-.06,9.58,2.69,53.76,2.69,53.76s3.92,4.95,12.43,0l2.89-49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,339.24l-1.54,7.7s-1.06,2.56-5.45,2.72a6.59,6.59,0,0,1-5.82-2.79l.62-8.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.18,292c-.81,4.42-4.11,48.72-4.11,48.72s4.35,6.06,12.86,1.1L349,298.59Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.47,309v61.21a1.78,1.78,0,0,1-.81,1.4l-2.19,1.27a1.84,1.84,0,0,1-1.62,0l-2.19-1.26a1.84,1.84,0,0,1-.81-1.41V309a2.76,2.76,0,0,1,2.75-2.76h2.12A2.76,2.76,0,0,1,354.47,309Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.76,306.22h0a1.91,1.91,0,0,1,1.9,1.91v64.26c0,.51-.36.72-.81.47l-2.22-1.28a1.74,1.74,0,0,1-.78-1.36V308.13A1.91,1.91,0,0,1,348.76,306.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.09,309v61.21a1.79,1.79,0,0,0,.82,1.4l2.18,1.27a1.87,1.87,0,0,0,1.63,0l2.18-1.26a1.81,1.81,0,0,0,.81-1.41V309a2.76,2.76,0,0,0-2.75-2.76h-2.12A2.76,2.76,0,0,0,428.09,309Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.81,306.22h0a1.92,1.92,0,0,0-1.91,1.91v64.26c0,.51.37.72.81.47l2.22-1.28a1.74,1.74,0,0,0,.78-1.36V308.13A1.91,1.91,0,0,0,433.81,306.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,330.61v63a1.79,1.79,0,0,1-.81,1.41l-2.19,1.26a1.78,1.78,0,0,1-1.62,0l-2.19-1.26a1.82,1.82,0,0,1-.81-1.41v-63a.94.94,0,0,1,.94-.93h5.74A.94.94,0,0,1,395.09,330.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.41,329.68h1.93a.94.94,0,0,1,.94.93v65.23c0,.52-.36.73-.81.47l-2.19-1.26a1.82,1.82,0,0,1-.81-1.41v-63A.94.94,0,0,1,388.41,329.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,310.45v.85a5.48,5.48,0,0,0,2,4l45.2,25.93a4.21,4.21,0,0,0,4.2.21L439,315.17a4.8,4.8,0,0,0,2.16-3.75v-.86a4.27,4.27,0,0,0-2.27-3.55L393.32,280.7a5.42,5.42,0,0,0-4.44.2l-44.69,25.8A4.8,4.8,0,0,0,342,310.45Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.19,306.7l44.69-25.8a5.42,5.42,0,0,1,4.44-.2L438.89,307c1.25.58,1.3,1.61.11,2.3l-45.55,26.23a4.21,4.21,0,0,1-4.2-.22l-45.2-25.9A1.5,1.5,0,0,1,344.19,306.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "350.57 210.78 320.59 226.42 335.49 267.15 363.46 251.48 350.57 210.78",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.19 214.76 324.04 227.89 337.23 262.9 360.7 249.76 349.19 214.76",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.89,218.54l-.49-1.24c-.27-.69-2.36-.28-4.68.91l-4.42,2.29c-2.32,1.19-4,2.72-3.71,3.41l.49,1.24Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.4,213.56c-.17-.43-1.08-.36-2,.16l-1.74.93s-1.07-2.69-5.05-.83-3.08,5-3.08,5l-1.84,1c-1,.56-1.74,1.37-1.62,1.8l.22.8,15.45-8.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.73,215.37c-1.43.7-2,1-1.58,2.1.47,1.22.91,2.09.91,2.09l-6.83,3.57s-.57-1.54-.82-2.14-.75-.87-1.84-.31l-.4-.42,10.77-5.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.18,218.61l-.49-1.25c-.27-.69-2.36-.28-4.67.92l-4.43,2.28c-2.31,1.2-4,2.72-3.7,3.41l.49,1.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.51,290.53s-39.71-12-46.61-13.87-20.15-5.07-24-3.34-5.83,3.75-6.19,9.33c-.07,1.05,0,6.16,0,6.16s19.19,5.94,34.92,5.94S427.51,290.53,427.51,290.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.99 223.03 393.7 237.5 407.65 242.11 409.56 222.44 393.99 223.03",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,209.14s-3.07,5.37-2.57,5.84,3.09.83,3.09.83Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.43,191.47c-3,2.08-6.23,5.93-7.47,17.13-1.35,12.28,1.59,16.23,3,17.25,2,1.52,10.13,1.27,13-.06,3.62-1.67,10.71-6.2,13.71-13,3.54-8,3.18-17.93-2.52-21.1C402.1,187.24,393,189.7,390.43,191.47Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32,195.92a21,21,0,0,0,5.72,4.63c1.39,2.2-.84,8.26,2.21,9.73,0,0,1.4-4.59,5.28-3.83s4.22,5.79,1.61,8.73-4.87,1.67-4.87,1.67a9,9,0,0,0,3.51,8.06,11.35,11.35,0,0,0,10.43,1.21c2.64-1,7.06-4.69,9.53-9.59,5.21-10.37,6.42-18.88-.21-22-.52-4.91-2.57-6.87-6.91-8.07-9.32-2.58-16.87,3.16-24.73,1.54C382.79,187.12,383,193.11,385.32,195.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.66,190.94l4.83-2.07a2.63,2.63,0,1,0-4.83,2.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.18,285.88c0,7.63,1,15.86-2.21,21.45-3.07,5.41-16.61,16.68-32.84,13.95-10.6-1.79-44.86-14.84-44.86-14.84s-15.16-5.61-15.23-9.6c0-1-.1-2,0-3,.32-5.31,2.47-11,13.56-10.73,12.12.32,48.08,6.21,48.08,6.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.93,237.74c-1.31-4-6.71-9.61-11.77-8.67-9.29,1.73-19.45,4.74-22.15,5.53h0s1.21,20.48-9.3,26.68l-.37,36s.76,2.57,4.77,5.12c4.34,2.76,12.74,4,23.3,1.11,14.19-3.85,16.77-12,16.77-12s-.11-24.14,0-35.18C426.28,246.34,425.83,240.48,424.93,237.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.66,266.09s5.27-5.46,7.21-12.07c0,0,.29,9.85-7.24,15.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,234.6c-5.74,1.72-9.23,2-15.57,11.78s-20.68,28-22.05,30.35c-1.91,3.23-2.27,8.14-.62,11.11,1.54,2.78,5.24,1.14,11.53-4.37,6.08-5.34,18.91-20,18.91-20A103.58,103.58,0,0,0,391,234.6Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,234.6a43.73,43.73,0,0,0-8.29,2.63,15,15,0,0,0-7.07,4.88c-5.15,6.88-11.79,18.51-11.79,18.51s1.18,9,12.27,12.2l5.45-6.64a32.92,32.92,0,0,0,5.88-8.76C390,251.93,392.81,243.22,391,234.6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.7,289.21c-5.31-.64-16.76-16.69-20.28-22.18a39.16,39.16,0,0,0-10.74-11.32c-5.61-4.15-4.8-10.53-2.35-16.37.85-2,3.73-.71,3.73-.71l1,2.78,1.76,4.8c1.19,1.1,1.86,1.46,1.94,1.13.15-.62-.87-3.2-.84-5.89,0-3.24,2.29-1.11,3,0a39.33,39.33,0,0,1,2.39,5.34c1.13,2.9.67,5.83,2,7.81s19.86,19.68,19.86,19.68Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403,290.59v40.35a.91.91,0,0,0,.4.71l1.1.63a.89.89,0,0,0,.81,0l1.09-.63a.9.9,0,0,0,.41-.71V290.59a1.38,1.38,0,0,0-1.38-1.38h-1.06A1.37,1.37,0,0,0,403,290.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.88,289.21h0a1,1,0,0,0-1,1V332c0,.26.19.37.41.24l1.11-.64a.89.89,0,0,0,.39-.68v-40.8A1,1,0,0,0,405.88,289.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.33,279.1v40.35a.91.91,0,0,0,.4.71l1.1.63a.89.89,0,0,0,.81,0l1.09-.63a.92.92,0,0,0,.41-.71V279.1a1.38,1.38,0,0,0-1.38-1.38H424.7A1.37,1.37,0,0,0,423.33,279.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.18,277.72h0a1,1,0,0,0-.95.95v41.88c0,.26.19.37.41.24l1.11-.64a.89.89,0,0,0,.39-.68v-40.8A1,1,0,0,0,426.18,277.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.39,245.47a5.23,5.23,0,0,0-4.3-.13L395,262a4,4,0,0,0-1.59,1.44l-.17.28c-.08.16-.16.32-.23.49a3.58,3.58,0,0,0-.28,1.34v26.72a4.66,4.66,0,0,0,2,3.68,5.29,5.29,0,0,0,4.07.21,1.09,1.09,0,0,0,.23-.09l1.79-.83,34.29-15.84a4.24,4.24,0,0,0,2.27-3.54V249.14A4.65,4.65,0,0,0,435.39,245.47Z",
    style: {
      fill: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.42,249.14a1.48,1.48,0,0,0-2.27-1.45l-36.08,16.66a4.07,4.07,0,0,0-1.59,1.45l-4.06-2.35A4,4,0,0,1,395,262l36.08-16.67a5.23,5.23,0,0,1,4.3.13A4.65,4.65,0,0,1,437.42,249.14Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.84,296.17a5.29,5.29,0,0,1-4.07-.21,4.66,4.66,0,0,1-2-3.68V265.56a3.58,3.58,0,0,1,.28-1.34c.07-.17.15-.33.23-.49l.17-.28,4.06,2.35a4,4,0,0,0-.68,2.1v26.73A1.45,1.45,0,0,0,398.84,296.17Z",
    style: {
      opacity: 0.1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultancyTraining);
export default __webpack_public_path__ + "static/media/consultancy-training.e30356dfd967e161754b55264612876b.svg";
export { ForwardRef as ReactComponent };